export const photoGalleryData = [
  {
    title: 'NutriCare Community Service',
    description: 'Volunteering at NutriCare food distribution event',
    category: 'NutriCare',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/0c31a1347f5f1fba35089902b4833f6a.jpeg'
  },
  {
    title: 'NutriCare Community Service',
    description: 'Volunteering at NutriCare food distribution event',
    category: 'NutriCare',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/7538f530f0a32fea922ccbf9fe212812.jpeg'
  },
  {
    title: 'NutriCare Team Volunteer',
    description: 'Team volunteering at NutriCare community outreach',
    category: 'NutriCare',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/66a0d497def3e476f72f2faa0087b63f.jpeg'
  },
  {
    title: 'NutriCare Community Impact',
    description: 'Making a difference through NutriCare volunteer initiatives',
    category: 'NutriCare',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/093f2ca59cbce1da82eda586f1528ee7.jpeg'
  },
  {
    title: 'NutriCare Volunteer Team',
    description: 'Working together at NutriCare community service event',
    category: 'NutriCare',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/f564485bd504c166780bdb9b621faa4b.jpeg'
  },
  {
    title: 'NutriCare Community Gathering',
    description: 'Engaging with community members at NutriCare event',
    category: 'NutriCare',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/e6f76e7284021e09f38e85636cbcd448.jpeg'
  },
  {
    title: 'NutriCare Outreach Program',
    description: 'Supporting families through NutriCare community programs',
    category: 'NutriCare',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/0100ad10e2e409c2a0570977ee420745.jpeg'
  },
  {
    title: 'NutriCare Food Distribution',
    description: 'Helping distribute food to families in need at NutriCare event',
    category: 'NutriCare',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/cec81bb8774d253843af3ad2f7c7bf46.jpeg'
  },
  {
    title: 'The Hispanic League Presentation',
    description: 'Presenting at The Hispanic League educational event',
    category: 'The Hispanic League',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/4b2d52a81e05b2cba49ae9c8431333df.jpeg'
  },
  {
    title: 'The Hispanic League Classroom Session',
    description: 'Leading educational session at The Hispanic League program',
    category: 'The Hispanic League',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/08cee02243c772f70058468e1f65ebbc.jpeg'
  },
  {
    title: 'The Hispanic League Community Engagement',
    description: 'Engaging with students at The Hispanic League educational initiative',
    category: 'The Hispanic League',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/04ddfdce50aeb4623aa306001108b34f.jpeg'
  },
  {
    title: 'The Hispanic League Educational Workshop',
    description: 'Facilitating interactive workshop at The Hispanic League program',
    category: 'The Hispanic League',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/327cf67e56b739c82a4f26c1c39a5971.jpeg'
  },
  {
    title: 'Gables Voice Leadership',
    description: 'Leading Gables Voice student journalism initiative',
    category: 'Gables Voice',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/68f3e50136cc6c88823b941074fc0827.jpeg'
  },
  {
    title: 'Gables Voice Event',
    description: 'Capturing memorable moments at Gables Voice event',
    category: 'Gables Voice',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/6ad6f47e2c5c601d94782a4259a4de1f.png'
  },
  {
    title: 'Gables Voice Career Fair',
    description: 'Engaging with students at Gables Voice career fair event',
    category: 'Gables Voice',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/35736cd8f58457dfa975eacebbb877c9.png'
  },
  {
    title: 'Gables Voice Fun Moment',
    description: 'Celebrating Gables Voice pride with school mascot',
    category: 'Gables Voice',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/ce64aecdc053f99f95cfef6837b084d7.png'
  },
  {
    title: 'Gables Voice Team Gathering',
    description: 'Team photo at Gables Voice student journalism event',
    category: 'Gables Voice',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/2304cf970edc013986009324165940c1.png'
  },
  {
    title: 'Gables Voice Club Fair',
    description: 'Representing Gables Voice at school club fair event',
    category: 'Gables Voice',
    url: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/105429eecfc9a2779bf2bc76f524db71.png'
  }
];
